import {svgIconWrapper} from '../svg-icon-wrapper';

import WarningOutline from './warning-outline-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <WarningOutline {...props} />;
}
SvgComponent.iconName = 'warningOutline';

export const WarningOutlineIcon = svgIconWrapper(SvgComponent);
